module.exports = __webpack_public_path__ + "static/Profile_BjornErik-4a3ac6befdc3ec15b03b32aa22843959.jpg";